<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="caja-operacion" titulo="Caja" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="enviar()">
              <section class="hero is-primary">
                <div class="hero-body">

                  <!-- Opciones  -->

                  <nav class="level">
                    <!-- Left side -->
                    <div class="level-left">
                      <div class="level-item">
                        <p class="title">
                          <span *ngIf="!ctrl.cargando" class="icon is-medium">
                            <i class="fa fa-archive"></i>
                          </span>
                          <span *ngIf="ctrl.cargando" class="icon is-medium">
                            <i class="fa fa-refresh fa-spin"></i>
                          </span>
                          <span class="icon is-medium">
                            <i class="fa" [ngClass]="ctrl.moduloTitulo == 'Nuevo' ? 'fa-file': 'fa-edit'"></i>
                          </span> Caja
                        </p>
                      </div>

                    </div>

                    <!-- Right side -->
                    <div class="level-right">
                      <a class="navbar-item tooltip" (click)="ctrl.regresar()">
                        <span class="icon fa-2x">
                          <i class="fa fa-arrow-left"> </i>
                        </span>
                        <span class="tooltiptext">Regresar</span>
                      </a>

                      <a class="navbar-item tooltip" (click)="ctrl.cargarDatos()" id='cargar_datos_actualizar' *ngIf="tiene_id">
                        <span class="icon fa-2x">
                          <i class="fa fa-refresh"></i>
                        </span>
                        <span class="tooltiptext">Actualizar</span>
                      </a>

                      <a class="navbar-item tooltip" (click)="imprimir()" id="impirmir_cierre">
                        <span class="icon fa-2x">
                          <i class="fa fa-print"></i>
                        </span>
                        <span class="tooltiptext">Imprimir</span>
                      </a>

                      <button class="navbar-item  is-success tooltip" type="submit" [ngClass]="{'is-loading': cargando}" [disabled]="ctrl.dato.invalid || cargando"
                        *ngIf="(permisos.indexOf( 'CajaOperacionController.store') > -1 ) && !tiene_id">
                        <span class="icon fa-2x has-text-success">
                          <i class="fa fa-save"> </i>
                        </span>
                        <span class="tooltiptext">Abrir Caja</span>
                      </button>

                      <button class="navbar-item  is-success tooltip" type="submit" [ngClass]="{'is-loading': cargando}" [disabled]="ctrl.dato.invalid || cargando"
                        *ngIf="(permisos.indexOf( 'CajaOperacionController.store') > -1 ) && tiene_id" (click)="cerrar_caja = true;">
                        <span class="icon fa-2x has-text-black">
                          <i class="fa fa-save"> </i>
                        </span>
                        <span class="tooltiptext">Cerrar Caja</span>
                      </button>

                      <button class="navbar-item  is-danger tooltip" type="button" [ngClass]="{'is-loading': ctrl.cargando}"
                        (click)="ctrl.eliminar(ctrl.id)" *ngIf="(permisos.indexOf('CajaOperacionController.destroy') > -1 ) && ctrl.id">
                        <span class="icon fa-2x has-text-danger">
                          <i class="fa fa-trash"></i>
                        </span>
                        <span class="tooltiptext">Eliminar</span>
                      </button>
                    </div>
                  </nav>
                </div>
              </section>

              <section class="section" style="padding: 2rem 2rem !important; overflow:auto;" [style.height.px]="ctrl.tamano-160">
                <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                <a id="catalogos" (click)="ctrl.cargarCatalogo('cajas', 'caja'); ctrl.cargarCatalogo('logos64', 'logos64', 'logo64');"></a>
                <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>
                <a id="recargar" (click)="cargarDato(ctrl.dato);"></a>
                <div class="notification is-{{exito}}" *ngIf="mensaje.length">
                  {{mensaje}}
                </div>
                <div class="tabs is-boxed" style="margin-top: -10px;">
                  <ul>
                    <li [ngClass]="{ 'is-active' : tab == 1}" *ngIf="!tiene_id">
                      <a (click)="tab=1">
                        <span class="icon">
                          <i class="fa fa-credit-card"></i>
                        </span>
                        <span>Abrir caja</span>
                      </a>
                    </li>

                    <li [ngClass]="{ 'is-active' : tab == 2}" *ngIf="tiene_id">
                      <a (click)="tab=2">
                        <span class="icon">
                          <i class="fa fa-credit-card-alt"></i>
                        </span>
                        <span>Corte de caja</span>
                      </a>
                    </li>

                    <li [ngClass]="{ 'is-active' : tab == 3}" *ngIf="json?.pagos.length > 0">
                      <a (click)="tab=3">
                        <span class="icon">
                          <i class="fa fa-info-circle"></i>
                        </span>
                        <span>Movimientos</span>
                      </a>
                    </li>

                    <li [ngClass]="{ 'is-active' : tab == 4}" *ngIf="json?.flujos_efectivos.length > 0">
                      <a (click)="tab=4">
                        <span class="icon">
                          <i class="fa fa-money"></i>
                        </span>
                        <span>Flujos de efectivo</span>
                      </a>
                    </li>
                  </ul>
                </div>

                <!-- Caja -->
                <div [ngClass]="{ 'is-hidden': tab != 1}">

                  <div class="field" formGroupName="abrio">
                    <label class="label">Persona que abre:</label>
                    <p class="control has-icons-left has-icons-right">
                      <input class="input" type="text" formControlName="nombre" readonly>
                    </p>
                  </div>
                  <div class="field">
                    <label class="label">Fecha y hora de apertura:</label>
                    <p class="control has-icons-left has-icons-right">
                      <input class="input" type="text" formControlName="fecha_apertura" readonly>
                    </p>
                  </div>

                  <div class="field">
                    <label class="label">Seleccione la caja a abrir:</label>
                    <div class="control has-icons-left has-icons-right">
                      <div class="select">
                        <select class="select" name="cajas_id" formControlName="cajas_id">
                          <option *ngFor="let val of ctrl.cajas" value="{{val.id}}">{{ val.nombre }}</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="field">
                    <label class="label">Provisión Inicial:</label>
                    <p class="control has-icons-left has-icons-right">
                      <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('provision_inicial').hasError('required') && ctrl.dato.get('provision_inicial').hasError('required')}"
                        placeholder="Escriba la cantidad $ con que inicia la caja" formControlName="provision_inicial">
                      <span class="icon" *ngIf="ctrl.dato.get('provision_inicial').hasError('required') && ctrl.dato.get('provision_inicial').hasError('required')">
                        <i class="fa fa-warning"></i>
                      </span>
                      <span class="help is-danger" *ngIf="ctrl.dato.get('provision_inicial').hasError('required') && ctrl.dato.get('provision_inicial').hasError('required')">Este
                        campo es requerido.</span>
                    </p>
                  </div>
                </div>

                <!-- Corte -->
                <div [ngClass]="{ 'is-hidden': tab != 2}">
                  <div class="box" id="imprimir">
                    <div class="box-header">
                      <p align="center" id="datos">
                        <strong>{{ctrl.configuracion.empresa.nombre}}</strong>
                        <br> {{ctrl.configuracion.empresa.direccion}}
                        <br> Tel: {{ctrl.configuracion.empresa.telefono}}
                        <br>
                        <br>
                        <strong> Suc: {{ctrl.configuracion.sucursal.nombre}}</strong>
                        <br> {{ctrl.configuracion.sucursal.direccion}}
                      </p>
                      <br>

                    </div>
                    <!-- resumen -->
                    <div class="media-content">
                      <div class="content" >

                        <table class="table is-striped  is-fullwidth" width="100%" border="1" align="center" id="detalle1">
                          <thead>
                            <tr>
                              <th colspan="4">
                                <h2 align="center">CORTE DE CAJA</h2>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td width="25%">
                                <strong>Fecha Apertura: </strong>
                              </td>
                              <td width="25%">
                                {{ ctrl.dato.get('fecha_apertura').value }}
                              </td>
                              <td width="25%">
                                <strong>Fecha Cierre: </strong>
                              </td>
                              <td width="25%">
                                {{ ctrl.dato.get('fecha_cierre').value }}
                              </td>
                            </tr>
                            <tr>
                              <td width="25%">
                                <strong>Caja: </strong>
                              </td>
                              <td width="25%">
                                {{ ctrl.dato.get('cajas').value.nombre }}
                              </td>
                              <td width="25%">
                                <strong>Importe de cierre: </strong>
                              </td>
                              <td width="25%">
                                {{((ctrl.dato.get('venta_total').value * 1) + (ctrl.dato.get('provision_inicial').value *1)) | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                              </td>
                            </tr>
                            <tr>
                              <td width="25%">
                                <strong>Abierto Por: </strong>
                              </td>
                              <td width="25%">
                                {{ ctrl.dato.get('abrio').value.nombre }}
                              </td>
                              <td width="25%">
                                <strong>Cerrado Por: </strong>
                              </td>
                              <td width="25%">
                                {{ ctrl.dato.get('cerro').value.nombre }}
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <table class="table is-striped  is-fullwidth" width="100%" border="1" align="center" id="detalle2">
                          <thead>
                            <tr>
                              <th colspan="4">
                                <h2 align="center">RESUMEN DE MOVIMINETOS</h2>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngIf="json?.pagos_entradas.length > 0">
                              <td colspan="4">
                                <h5>Entradas</h5>
                                <table class="table is-striped  is-fullwidth" width="100%" border="1" align="center" style="color:red">
                                  <tbody *ngFor=" let item of ctrl.dato.get('pagos_entradas').value; let i = index">
                                    <tr *ngIf="item.nombre != ''">
                                      <td align="right" width="24.8%">
                                        <strong>{{item.nombre}}</strong>
                                      </td>
                                      <td>
                                        {{item.total | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                      </td>
                                      <td width="20%">{{item.tipo}}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>

                            <tr *ngIf="json?.pagos_salidas.length > 0">
                              <td colspan="4">
                                <h5>Salidas</h5>
                                <table class="table is-striped  is-fullwidth" width="100%" border="1" align="center">
                                  <tbody *ngFor=" let item of json?.pagos_salidas; let i = index">
                                    <tr *ngIf="item.nombre != ''">
                                      <td align="right" width="24.8%">
                                        <strong>{{item.nombre}}</strong>
                                      </td>
                                      <td>
                                        {{item.total | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                      </td>
                                      <td width="20%">{{item.tipo}}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr *ngIf="json?.pagos_salidas.length > 0">
                              <td colspan="4" align="center">
                                <table class="table is-striped  is-fullwidth" width="100%" border="1" align="center">
                                  <tbody>
                                    <tr>
                                      <td align="right" width="24.8%">
                                        <strong>Total Movimientos: </strong>
                                      </td>
                                      <td>
                                        {{ctrl.dato.get('importe_cierre').value | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="right">
                                        <strong>F.E. Entrada: </strong>
                                      </td>
                                      <td *ngIf="json?.flujos_agrupados">
                                        {{(json?.flujos_agrupados.length > 1 ? json?.flujos_agrupados[1].total : 0) | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="right">
                                        <strong style="color:red">F.E. Salidad: </strong>
                                      </td>
                                      <td style="color:red" *ngIf="json?.flujos_agrupados">
                                        {{(json?.flujos_agrupados.length > 0 ? json?.flujos_agrupados[0].total : 0) | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="right">
                                        <strong>Provisión Inicial: </strong>
                                      </td>
                                      <td *ngIf="json?.flujos_agrupados">
                                        {{ctrl.dato.get('provision_inicial').value | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="right">
                                        <h4>
                                          <strong>Total en Caja: </strong>
                                        </h4>
                                      </td>
                                      <td>
                                        <h4>
                                          {{((ctrl.dato.get('venta_total').value * 1) + (ctrl.dato.get('provision_inicial').value *1)) | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                        </h4>
                                      </td>
                                    </tr>

                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div id="firma" align="center">
                          <br>
                          <br>
                          <br>
                          <hr align="center" style="border:#333 solid 2px; width:50%; "> Firma de quien entrega
                        </div>
                      </div>
                    </div>
                    <!-- fin resumen -->
                  </div>
                </div>

                <!-- movimientos -->
                <div [ngClass]="{ 'is-hidden': tab != 3}">
                  <table class="table is-striped  is-fullwidth" width="100%" border="1" align="center">
                    <thead>
                      <tr>
                        <th>Movimiento</th>
                        <th>Tipo Movimiento</th>
                        <th>Método de pago</th>
                        <th>Paga con</th>
                        <th>Cambio</th>
                        <th>Importe</th>
                        <th>Usuario</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor=" let item of json?.pagos; let i = index">
                        <td>{{item.movimientos?.codigo}} </td>
                        <td>{{json?.tipos_movimientos[item.movimientos.tipos_movimientos_id - 1].nombre}}</td>
                        <td>({{item.tipos_metodos_pagos_id}}) {{item.tipos_formas_pagos.nombre}}</td>
                        <td [style.background]="item.tipos_formas_pagos_id == '06' || item.tipos_formas_pagos_id == '05' ? '#f68686' : '#aff2af'">
                          {{item.paga_con | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                        </td>
                        <td>
                          {{item.cambio | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                        </td>
                        <td>
                          <strong>{{item.importe | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}</strong>
                        </td>
                        <td>{{item.usuarios.nombre}}<br> {{item.created_at}} || {{item.updated_at}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- flujos -->
                <div [ngClass]="{ 'is-hidden': tab != 4}">
                  <table class="table is-striped  is-fullwidth" width="100%" border="1" align="center">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Tipo</th>
                        <th>Comentario</th>
                        <th>Fecha Solicitud</th>
                        <th>Fecha Autorizado</th>
                        <th>Importe</th>
                        <th>Solicita</th>
                        <th>Autoriza</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor=" let item of json?.flujos_efectivos; let i = index" >
                        <td>{{item.id}} </td>
                        <td>{{item.tipos_flujos_efectivos_id == 0 ? 'Salida' : 'Entrada'}}</td>
                        <td>
                          {{item.comentarios}}
                        </td>
                        <td>
                          {{item.fecha_solicitud}}
                        </td>
                        <td>
                          {{item.fecha_autorizado}}
                        </td>
                        <td>
                          <strong>{{item.importe | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}</strong>
                        </td>
                        <td>{{item.solicita.nombre}}</td>
                        <td>{{item.autoriza.nombre}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>
            </form>
        </div>
    </div>
</div>
